<template>
    <div class="d-flex flex-row justify-space-between horizontal-divider">
        <div class="client">
            <h3 class="text-capitalize">{{ indicatorName }}</h3>
            <p>Track {{ level }} progress here</p>
        </div>
        <div v-if="brandIndicators && brandIndicators.length">
            <!-- Brand Indicators -->
        </div>
    </div>
</template>
<script>
export default {
    name: "BrandIndicator",
    data() {
        return {

        }
    },
    props: {
        level: {
            type: String,
            required: true
        },
        indicatorName: {
            type: String,
            required: true
        },
        brandIndicators: {
            type: Array,
        }
    },
    mounted() {

    }
}
</script>
<style>
.client h3 {
    font-family: Poppins;
    font-size: 32px;
    font-weight: 500;
    line-height: 43.52px;
    letter-spacing: -0.01em;
}

.client p {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.76px;
    letter-spacing: -0.01em;
}
</style>